module.exports = __webpack_public_path__ + "img/partners_6.52c9ee83.png";